import { render, staticRenderFns } from "./Organizational.vue?vue&type=template&id=c50ef87c&scoped=true&"
import script from "./Organizational.vue?vue&type=script&lang=js&"
export * from "./Organizational.vue?vue&type=script&lang=js&"
import style0 from "./Organizational.vue?vue&type=style&index=0&id=c50ef87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50ef87c",
  null
  
)

export default component.exports